/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PersonHandleType } from './PersonHandleType';
import {
    PersonHandleTypeFromJSON,
    PersonHandleTypeFromJSONTyped,
    PersonHandleTypeToJSON,
} from './PersonHandleType';

/**
 * 
 * @export
 * @interface PersonHandle
 */
export interface PersonHandle {
    /**
     * 
     * @type {PersonHandleType}
     * @memberof PersonHandle
     */
    type: PersonHandleType;
    /**
     * 
     * @type {string}
     * @memberof PersonHandle
     */
    value: string;
}

/**
 * Check if a given object implements the PersonHandle interface.
 */
export function instanceOfPersonHandle(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PersonHandleFromJSON(json: any): PersonHandle {
    return PersonHandleFromJSONTyped(json, false);
}

export function PersonHandleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonHandle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PersonHandleTypeFromJSON(json['type']),
        'value': json['value'],
    };
}

export function PersonHandleToJSON(value?: PersonHandle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PersonHandleTypeToJSON(value.type),
        'value': value.value,
    };
}

